import { useMemo } from "react";

import { useAppShellBreadcrumb } from "@/shared/components/layout/useAppShellBreadcrumb";
import useTranslations from "@/shared/lang/useTranslations";

import { QuoterForm } from "../components/QuoterForm";
import { QUOTER_COUNTRIES } from "../constants/quoter.constants";
import { buildCurrencyOptionsFromCountries } from "../utils/currencyOptions.utils";

// The country/currency table is a local constant now (the legacy PHP catalog fetch is gone),
// so there is no loading or error state to render.
const CURRENCY_OPTIONS = buildCurrencyOptionsFromCountries(QUOTER_COUNTRIES);

export const QuoterPage = () => {
  const { t: tGlobal } = useTranslations("global");
  const breadcrumb = useMemo(
    () => [
      { label: tGlobal("sidebar_section_gestion") },
      { label: tGlobal("sidebar_menu_quoter"), to: "/app/quoter" },
    ],
    [tGlobal],
  );
  useAppShellBreadcrumb(breadcrumb);

  // Access is enforced by the route-level `RequireAccess` gate (operations:shipping_quotes:read +
  // userTypes: [INTERNAL], read off shipping-quotes and rates controllers). The old local check
  // defaulted to `true` for every role but `operator`, so it let more people in than the API does.
  return (
    <div className="space-y-6 p-2 flex justify-center">
      <QuoterForm currencyOptions={CURRENCY_OPTIONS} />
    </div>
  );
};
